import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import ActionButton from 'components/ActionButton';

const CommonViewButton = ({ onView }) => (
  <Row middle="xs" end="xs">
    <Col xs>
      <ActionButton localeId="dictionary.show" condensed secondary onClick={onView} />
    </Col>
  </Row>
);

CommonViewButton.propTypes = {
  onView: PropTypes.func.isRequired,
};

export default CommonViewButton;
